
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["text-grey-600",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","class":"text-grey-600"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentcolor","d":"M18 15.5a1 1 0 01-.71-.29l-4.58-4.59a1 1 0 00-1.42 0l-4.58 4.59a1 1 0 01-1.42-1.42l4.59-4.58a3.06 3.06 0 014.24 0l4.59 4.58a1 1 0 010 1.42 1 1 0 01-.71.29z"}})])
          )
        }
      }
    